import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';

// Default theme that will be updated by system configuration
const defaultTheme = {
  primary: '#1976D2',
  secondary: '#FFFFFF',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
};

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: defaultTheme
});
